import { getCount, getPositionColumn } from '../utils';

import { target } from './target';

// ----------------------------------------------------------------------------

function maximize(elementColumn: HTMLElement): Record<string, any> | undefined {
    if (!(elementColumn instanceof HTMLTableCellElement)) {
        return;
    }

    const elTable = elementColumn.closest('table');

    if (!(elTable instanceof HTMLTableElement)) {
        return;
    }

    const count = getCount(elTable);

    if (count.rowCount <= 1 && count.columnCount <= 1) {
        return;
    }

    const pos = getPositionColumn(elementColumn);

    return target(elTable, {
        rowCount: pos.rowIndex,
        columnCount: pos.columnIndex,
    });
}

// ----------------------------------------------------------------------------

export { maximize };
